const formatter = new Intl.NumberFormat('es-ES', {
  useGrouping: true,
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
});

// Presentation only: API numbers keep their original precision for calculations.
export function formatPreferenceNumber(value, { percentRatio = false } = {}) {
  if (typeof value !== 'number' &&
      (typeof value !== 'string' || !/^[+-]?(?:\d+\.?\d*|\.\d+)(?:e[+-]?\d+)?$/i.test(value.trim()))) return '-';
  const number = Number(value) * (percentRatio ? 100 : 1);
  if (!Number.isFinite(number)) return '-';
  // es-ES normally omits grouping for four-digit integers; group those too.
  return formatter.formatToParts(number).map(part => part.type === 'integer'
    ? part.value.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    : part.value).join('');
}
